import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import reducers from './reducers';
import { AUTH_USER } from './actions';
import { getAccessToken, getDecodedUserName, getDecodedUserId } from './utils/auth';
import App from './App';

const createStoreWithMiddleware = applyMiddleware(ReduxThunk)(createStore);

/* eslint-disable no-underscore-dangle */
const store = createStoreWithMiddleware(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);
/* eslint-enable */


const token = getAccessToken();

// If token exist in localstorage, consider the user to be signed in
if (token) {
  const user = {
    name: getDecodedUserName(),
    uid: getDecodedUserId(),
  };
  store.dispatch({ type: AUTH_USER, payload: user });
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js